import base from './base'
import axios from '@/utils/request'
export default {
    loginbytype(params) {
        return axios.get(base.loginbytype, params)
    },
    getUserInfo() {
        return axios.get(base.getUserInfo)
    },
    getqrcodebylogin() {
        return axios.get(base.getqrcodebylogin)
    },
    isqrlogin(params) {
        return axios.get(base.isqrlogin, params)
    },
    getregisterlist1(params) {
        return axios.get(base.getregisterlist1, params)
    },
    setregister1(params) {
        return axios.get(base.setregister1, params)
    },
    delregister1(params) {
        return axios.get(base.delregister1, params)
    },
    getcardmachinelist(params) {
        return axios.get(base.getcardmachinelist, params)
    },
    editcardmachinerecord(params) {
        return axios.get(base.editcardmachinerecord, params)
    },
    getcardmachinerecordlist(params) {
        return axios.get(base.getcardmachinerecordlist, params)
    },
    getm4backuplist(params) {
        return axios.get(base.getm4backuplist, params)
    },
    getappaccountlist(params) {
        return axios.get(base.getappaccountlist, params)
    },
    getblelocklist(params) {
        return axios.get(base.getblelocklist, params)
    },
    getlockrecord(params) {
        return axios.get(base.getlockrecord, params)
    },
    getgoodsdetail(params) {
        return axios.get(base.getgoodsdetail, params)
    },
    updateskuprice(params) {
        return axios.get(base.updateskuprice, params)
    },
    getgoodslist(params) {
        return axios.get(base.getgoodslist, params)
    },
    goodsedit(params,data) {
        return axios.post(base.goodsedit, params,data)
    },
    getgoodstemplatelist(params) {
        return axios.get(base.getgoodstemplatelist, params)
    },
    goodstemplateedit(params) {
        return axios.get(base.goodstemplateedit, params)
    },
    delgoodstemplate(params) {
        return axios.get(base.delgoodstemplate, params)
    }, 
    getgoodsvaluelist(params) {
        return axios.get(base.getgoodsvaluelist, params)
    }, 
    goodsvalueedit(params) {
        return axios.get(base.goodsvalueedit, params)
    }, 
    delgoodsvalue(params) {
        return axios.get(base.delgoodsvalue, params)
    }, 
    copygoodstemplate(params) {
        return axios.get(base.copygoodstemplate, params)
    },
    updategoodsku(params) {
        return axios.get(base.updategoodsku, params)
    },
    goodsshangjia(params) {
        return axios.get(base.goodsshangjia, params)
    }, 
    getgoodsorder(params) {
        return axios.get(base.getgoodsorder, params)
    }, 
    goodsdelivery(params) {
        return axios.get(base.goodsdelivery, params)
    }, 

    
       
    
    


}